"use client";

import { useEffect } from "react";
import { LINK_ACTIONS } from "@/utils/link-actions";

/**
 * Runs the action of links that stand in for a scripted link, wherever on the
 * page they are rendered.
 */
export function LinkActionHandler() {
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (!(event.target instanceof Element)) {
        return;
      }

      const link = event.target.closest<HTMLAnchorElement>("a[href]");
      const action = link ? LINK_ACTIONS[link.hash] : undefined;

      if (!action) {
        return;
      }

      event.preventDefault();
      action();
    };

    // Capture phase, so the link's own navigation sees the click as handled.
    document.addEventListener("click", handleClick, true);

    return () => document.removeEventListener("click", handleClick, true);
  }, []);

  return null;
}
